export var SxSCustomization;
(function (SxSCustomization) {
    SxSCustomization[SxSCustomization["Mail"] = 0] = "Mail";
    SxSCustomization[SxSCustomization["FilesHub"] = 1] = "FilesHub";
    SxSCustomization[SxSCustomization["DeepLink"] = 2] = "DeepLink";
    SxSCustomization[SxSCustomization["GroupFilesHub"] = 3] = "GroupFilesHub";
})(SxSCustomization || (SxSCustomization = {}));
//# sourceMappingURL=SxSStore.js.map